<template>
  <div>
    <!-- 支持拖拽排序模式 -->
    <div v-if="draggable" class="draggable-upload-list">
      <div
        v-for="(file, index) in fileList"
        :key="file.uid"
        class="draggable-upload-item"
        :class="{ 'drag-over': dragOverIndex === index }"
        draggable="true"
        @dragstart="handleDragStart(index)"
        @dragover.prevent="handleDragOver(index)"
        @drop.prevent="handleDrop(index)"
        @dragend="handleDragEnd"
      >
        <img :src="file.thumbUrl || file.url" class="draggable-upload-img" @click="handlePreview(file)" alt="" />
        <div class="draggable-upload-mask">
          <a-icon type="eye" @click="handlePreview(file)" />
          <a-icon type="delete" @click="removeFile(file)" />
        </div>
      </div>
      <a-upload
        listType="picture-card"
        :show-upload-list="false"
        :multiple="true"
        :before-upload="beforeUpload"
        :customRequest="customRequest"
      >
        <div v-if="maxCount === -1 || maxCount > fileList.length">
          <a-icon :type="loading ? 'loading' : 'plus'" />
          <div v-show="!loading" class="ant-upload-text">上传</div>
        </div>
      </a-upload>
    </div>
    <!-- 默认模式 -->
    <a-upload v-else v-model="fileList" listType="picture-card" :fileList="fileList" :remove="removeFile" :multiple="true"
              :show-upload-list="true" :before-upload="beforeUpload" :customRequest="customRequest" @preview="handlePreview">
      <div v-if="maxCount === -1 || maxCount > fileList.length">
        <a-icon :type="loading ? 'loading' : 'plus'" />
        <div v-show="!loading" class="ant-upload-text">上传</div>
      </div>
    </a-upload>
    <!-- 预览弹窗 -->
    <a-modal :visible="previewVisible" :footer="null" @cancel="previewCancel">
      <img v-if="type === 'img'" alt="example"  style="width: 100%" :src="previewImage" />
      <video v-else-if="type === 'video'" ref="previewVideo"  style="width: 100%" :src="previewImage" :poster="previewImage + '?x-oss-process=video/snapshot,t_0,f_jpg'" :controls="true">
        <source :src="previewImage" type="video/mp4" />
      </video>
      <div v-else>
        <div>
          文件暂不支持在线预览, 请点击下载至本地后, 进行查看 <br /> <a :href="previewImage">下载文件</a>
        </div>
      </div>
    </a-modal>
  </div>
</template>
<script>
import {generateFilePath, uploadObject, uploadOss} from "@/api/tool/oss";

export default {
  props: {
    value: String,
    type: String, // 文件类型, "img" 图片, "video" 视频, null 不限制类型
    // 最大文件大小, 单位 兆M, 默认 20兆
    maxSize: {
      type: Number,
      default: 20
    },
    /*文件夹前缀*/
    prefix: {
      type: String,
      default: "upload",
    },
    // 最大数量, 1 限制1张
    maxCount: {
      type: Number,
      default: 1
    },
    isArrayData: {
      type: Boolean,
      default: false,
    },
    // 是否开启拖拽排序(适用于轮播图等需要排序的场景)
    draggable: {
      type: Boolean,
      default: false,
    }
  },
  created() {
    this.valueChange(this.value);
  },
  data() {
    return {
      fileList: [], // 文件集合
      loading: false, // 加载状态
      previewVisible: false, // 预览弹窗隐藏/显示
      previewImage: '', // 预览 img url
      dragIndex: null, // 当前拖拽项索引
      dragOverIndex: null, // 拖拽悬浮项索引
    }
  },
  methods: {
    // 删除图片
    removeFile(file) {
      this.fileList = this.fileList.filter(item => item.url !== file.url);
      this.emitChange();
    },
    // 预览按钮点击
    handlePreview(file) {
      this.previewImage = file.url;
      this.previewVisible = true;
    },
    // 上传之前校验
    beforeUpload(file) {
      // 图片校验
      if (this.type == 'img' && !file.type.startsWith('image')) {
        this.$message.error('上传请上传图片文件');
        return false;
      }
      // 视频校验
      if (this.type == 'video' && !file.type.startsWith('video/mp4')) {
        this.$message.error('上传请上传 mp4 视频文件');
        return false;
      }
      // 大小校验
      if (file.size / 1024 / 1024 > this.maxSize) {
        this.$message.error(`上传文件大小不能超过 ${this.maxSize} MB`);
        return false;
      }
    },
    // 自定义上传请求
    customRequest(fileInfo, index) {
      this.loading = true;

      // 文件
      const uploadFile = fileInfo.file;

      // 文件夹目录
      const prefix = this.prefix
      const url = this.buildOssUrl(uploadFile.name, prefix);

      // oss 上传
      uploadObject(url, uploadFile).then(res => {
        this.fileList.push(this.createAntFileObj(res))
        this.$message.success('上传成功')
        this.loading = false;
        this.emitChange();
      })
    },
    // 构建 oss url
    buildOssUrl(fileName, prefix) {
      // 获取文件后缀
      const suffix = fileName.substring(fileName.lastIndexOf('.'))
      // 生成文件名称
      const filePath = generateFilePath(prefix, suffix)
      return filePath
    },
    // 文件随机 uid
    getUidRandom() {
      return Math.round(Math.random() * 80 + 20)
    },
    // 向父组件同步文件列表(数组或逗号字符串)
    emitChange() {
      const urls = this.fileList.map(item => item.url);
      this.$emit('input', this.isArrayData ? urls : urls.join(','));
    },
    // 拖拽开始
    handleDragStart(index) {
      this.dragIndex = index;
    },
    // 拖拽悬浮
    handleDragOver(index) {
      this.dragOverIndex = index;
    },
    // 拖拽放置: 将拖拽项移动到目标位置
    handleDrop(index) {
      if (this.dragIndex === null || this.dragIndex === index) {
        return;
      }
      const list = this.fileList;
      const dragItem = list[this.dragIndex];
      list.splice(this.dragIndex, 1);
      list.splice(index, 0, dragItem);
      this.dragIndex = null;
      this.dragOverIndex = null;
      this.emitChange();
    },
    // 拖拽结束
    handleDragEnd() {
      this.dragIndex = null;
      this.dragOverIndex = null;
    },
    // 预览关闭
    previewCancel() {
      this.previewVisible = false;
      // 视频暂停播放
      if (this.$refs.previewVideo) {
        this.$refs.previewVideo.pause();
      }
    },
    valueChange(newValue) {
      if (!newValue) {
        this.fileList = [];
        return;
      }
      if(typeof newValue === 'string') {
        const imgUrls = newValue.split(',');
        // 判断 url 是否存在, 不存在进行添加
        imgUrls.forEach(imgUrl => {
          for (let i = 0; i < this.fileList.length; i++) {
            const item = this.fileList[i];
            if (item.url == imgUrl) {
              return;
            }
          }
          this.fileList.push(this.createAntFileObj(imgUrl));
        });
      } else  {
        this.fileList = newValue.map(item => (this.createAntFileObj(item)))
      }

    },
    // 创建 ant fileList 的对象
    createAntFileObj(ossUrl) {
      return {
        status: 'done',
        url: ossUrl,
        uid: this.getUidRandom(),
        name: ossUrl,
        thumbUrl: this.getThumbUrl(ossUrl)
      };
    },
    // 预览图片
    getThumbUrl(ossUrl) {
      switch (this.type) {
        // 视频, 使用 oss 封面图功能, 文档: https://help.aliyun.com/zh/oss/user-guide/video-snapshots
        case "video":
          return ossUrl + "?x-oss-process=video/snapshot,t_0,f_jpg,w_0,h_0,m_fast";
        // 图片/默认
        case "img":
        default:
          return ossUrl;
      }
    }
  },
  watch: {
    // 监听上级 value 改变
    value(newValue) {
      this.valueChange(newValue);
    }
  }
}
</script>
<style scoped>
.draggable-upload-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.draggable-upload-item {
  width: 104px;
  height: 104px;
  box-sizing: border-box;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  position: relative;
  overflow: hidden;
  cursor: grab;
  background: #fff;
}
.draggable-upload-item:active {
  cursor: grabbing;
}
.draggable-upload-item.drag-over {
  border-color: #1890ff;
  box-shadow: 0 0 4px #1890ff;
}
.draggable-upload-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.draggable-upload-mask {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: none;
  align-items: center;
  justify-content: center;
  gap: 16px;
  color: #fff;
  font-size: 16px;
}
.draggable-upload-item:hover .draggable-upload-mask {
  display: flex;
}
.draggable-upload-mask .anticon {
  cursor: pointer;
}
</style>